(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4224],{

/***/ 56227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ BackButtonBar; },
/* harmony export */   "x": function() { return /* binding */ BackButton; }
/* harmony export */ });
/* harmony import */ var app_hooks_lang__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91289);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);
/* harmony import */ var _icons_ArrowBack__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40774);
/* harmony import */ var _back_button_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71345);
/* harmony import */ var _back_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_back_button_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






var BackButtonBar = function BackButtonBar(_ref) {
  var onClick = _ref.onClick,
      className = _ref.className,
      buttonClassName = _ref.buttonClassName;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    "data-navigate-row": true,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_back_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper), className),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BackButton, {
      onClick: onClick,
      className: buttonClassName
    })
  });
};
var BackButton = function BackButton(_ref2) {
  var onClick = _ref2.onClick,
      className = _ref2.className;
  var t = (0,app_hooks_lang__WEBPACK_IMPORTED_MODULE_4__/* .useTranslate */ .q)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
    "data-navigate-item": true,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_back_button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().back), className),
    onClick: onClick,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_icons_ArrowBack__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      children: t("back")
    })]
  });
};

/***/ }),

/***/ 80112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ Category; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./app/context/features.context.tsx
var features_context = __webpack_require__(10833);
// EXTERNAL MODULE: ./app/hooks/navigation.hook.ts
var navigation_hook = __webpack_require__(26793);
// EXTERNAL MODULE: ./app/premium-catalog.ts
var premium_catalog = __webpack_require__(81222);
// EXTERNAL MODULE: ./services-hooks/hooks.ts + 1 modules
var hooks = __webpack_require__(90413);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./app/components/category-list/category-list.module.scss
var category_list_module = __webpack_require__(52986);
var category_list_module_default = /*#__PURE__*/__webpack_require__.n(category_list_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./app/components/icons/Logo.tsx
var Logo = __webpack_require__(23583);
// EXTERNAL MODULE: ./app/components/icons/ArrowRight.tsx
var ArrowRight = __webpack_require__(8426);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useIntersection.js
var useIntersection = __webpack_require__(80621);
// EXTERNAL MODULE: ./app/utils/scroll.ts
var utils_scroll = __webpack_require__(21278);
// EXTERNAL MODULE: ./app/hooks/lang.ts + 22 modules
var lang = __webpack_require__(91289);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./app/components/category-list/category-list.component.tsx














var CategoryList = function CategoryList(_ref) {
  var items = _ref.items,
      label = _ref.label,
      loading = _ref.loading,
      _ref$isPremium = _ref.isPremium,
      isPremium = _ref$isPremium === void 0 ? false : _ref$isPremium,
      _ref$fetchNextPage = _ref.fetchNextPage,
      fetchNextPage = _ref$fetchNextPage === void 0 ? function () {} : _ref$fetchNextPage;

  var _useFeaturesContext = (0,features_context/* useFeaturesContext */.Pp)(),
      arrowNavigationEnabled = _useFeaturesContext.arrowNavigationEnabled;

  var t = (0,lang/* useTranslate */.q)();
  var elementsRef = (0,react.useRef)([]);
  var radioListRef = (0,react.useRef)(null);

  var onForward = function onForward() {
    var _radioListRef$current;

    (_radioListRef$current = radioListRef.current) === null || _radioListRef$current === void 0 ? void 0 : _radioListRef$current.scrollTo({
      left: (0,utils_scroll/* calculateCategoryScroll */.HE)(radioListRef.current.scrollLeft),
      behavior: "smooth"
    });
  };

  var onBackward = function onBackward() {
    var _radioListRef$current2;

    (_radioListRef$current2 = radioListRef.current) === null || _radioListRef$current2 === void 0 ? void 0 : _radioListRef$current2.scrollTo({
      left: (0,utils_scroll/* calculateCategoryScroll */.HE)(radioListRef.current.scrollLeft, true),
      behavior: "smooth"
    });
  };

  var loadMoreTriggerRef = (0,react.useRef)(null);
  var intersection = (0,useIntersection/* default */.Z)(loadMoreTriggerRef, {
    rootMargin: "0px",
    threshold: 1
  });
  (0,react.useEffect)(function () {
    if (intersection !== null && intersection !== void 0 && intersection.isIntersecting) {
      fetchNextPage();
    }
  }, [intersection]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (category_list_module_default()).wrapper,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
      className: (category_list_module_default()).header,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        children: [label, isPremium && /*#__PURE__*/(0,jsx_runtime.jsx)("em", {
          className: (category_list_module_default()).premium_label,
          children: t("premium.premium")
        })]
      }), !arrowNavigationEnabled && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (category_list_module_default()).buttons,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: (0,clsx_m/* default */.Z)((category_list_module_default()).arrow, (category_list_module_default()).arrow_back),
          onClick: function onClick() {
            return onBackward();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowRight/* default */.Z, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: (category_list_module_default()).arrow,
          onClick: function onClick() {
            return onForward();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowRight/* default */.Z, {})
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (category_list_module_default()).category_list,
      "data-navigate-row": true,
      "data-navigate-scrollable": true,
      ref: radioListRef,
      children: loading ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((category_list_module_default()).category, (category_list_module_default()).placeholder_item)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((category_list_module_default()).category, (category_list_module_default()).placeholder_item)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((category_list_module_default()).category, (category_list_module_default()).placeholder_item)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((category_list_module_default()).category, (category_list_module_default()).placeholder_item)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((category_list_module_default()).category, (category_list_module_default()).placeholder_item)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((category_list_module_default()).category, (category_list_module_default()).placeholder_item)
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [items.map(function (category, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/category/".concat(category.permalink),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              className: (category_list_module_default()).category,
              tabIndex: 0,
              "data-navigate-item": true,
              ref: function ref(e) {
                if (e) {
                  elementsRef.current[index] = e;
                }
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (category_list_module_default()).category_img,
                children: category.logo ? /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  className: (category_list_module_default()).cover,
                  src: category.logo,
                  width: 220,
                  height: 116,
                  layout: "fixed",
                  objectFit: "cover",
                  alt: category.name,
                  unoptimized: true
                }, "radio-station-".concat(index)) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (category_list_module_default()).cover_empty,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Logo/* default */.Z, {})
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (category_list_module_default()).category_details,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  className: (category_list_module_default()).category_name,
                  children: category.name
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (category_list_module_default()).category_description,
                  children: category.description
                })]
              })]
            }, "category-".concat(index))
          }, "category-item-".concat(category.permalink));
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: loadMoreTriggerRef
        })]
      })
    })]
  });
};
// EXTERNAL MODULE: ./app/components/podcats-list/podcast-list.component.tsx
var podcast_list_component = __webpack_require__(60151);
// EXTERNAL MODULE: ./app/components/stations-list/stations-list.component.tsx
var stations_list_component = __webpack_require__(79666);
// EXTERNAL MODULE: ./app/components/category/category.module.scss
var category_module = __webpack_require__(51041);
var category_module_default = /*#__PURE__*/__webpack_require__.n(category_module);
;// CONCATENATED MODULE: ./app/components/category/category.component.tsx












var Category = function Category(_ref) {
  var category = _ref.category,
      showDetailsOnClick = _ref.showDetailsOnClick,
      className = _ref.className,
      _ref$showStationNames = _ref.showStationNames,
      showStationNames = _ref$showStationNames === void 0 ? false : _ref$showStationNames,
      items = _ref.items;
  var navigatePath = (0,navigation_hook/* useNavigatePath */.xQ)();

  var _useGetPillowCategory = (0,hooks/* useGetPillowCategoryPath */.gn)(category.permalink, {
    pageSize: 20
  }),
      data = _useGetPillowCategory.data,
      isLoading = _useGetPillowCategory.isLoading,
      fetchNextPage = _useGetPillowCategory.fetchNextPage;

  var _useFeaturesContext = (0,features_context/* useFeaturesContext */.Pp)(),
      isCarMode = _useFeaturesContext.isCarMode;

  var mappedPages = (data === null || data === void 0 ? void 0 : data.pages.reduce(function (acc, current) {
    var _current$data$body;

    if ((_current$data$body = current.data.body) !== null && _current$data$body !== void 0 && _current$data$body.content) {
      acc = [].concat((0,toConsumableArray/* default */.Z)(acc), (0,toConsumableArray/* default */.Z)(current.data.body.content));
    }

    return acc;
  }, [])) || [];
  var stations = items.filter(function (category) {
    return category.type === "radio";
  });
  var podcasts = items.filter(function (category) {
    return category.type === "podcast";
  });
  var categories = items.filter(function (category) {
    return category.type === "category";
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [podcasts.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (category_module_default()).stations_wrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(podcast_list_component/* PodcastList */.k, {
        items: podcasts,
        label: category.name,
        loading: false,
        className: className
      })
    }), stations.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (category_module_default()).stations_wrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(stations_list_component/* StationsList */.e, {
        items: stations,
        label: category.name,
        loading: false,
        showDetailsOnClick: showDetailsOnClick,
        className: className,
        showStationNames: showStationNames
      })
    }), categories.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (category_module_default()).categories_wrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CategoryList, {
        label: category.name,
        items: categories,
        loading: false,
        isPremium: (0,premium_catalog/* isPremium */.I)(category.permalink)
      })
    })]
  });
};

/***/ }),

/***/ 48778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ CountrySelector; }
});

// EXTERNAL MODULE: ./app/hooks/go-back.hook.ts
var go_back_hook = __webpack_require__(71014);
// EXTERNAL MODULE: ./app/hooks/keyboard-navigation.hook.ts
var keyboard_navigation_hook = __webpack_require__(36158);
// EXTERNAL MODULE: ./app/hooks/modal-scroll.hook.ts
var modal_scroll_hook = __webpack_require__(76299);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./services-hooks/hooks.ts + 1 modules
var hooks = __webpack_require__(90413);
// EXTERNAL MODULE: ./app/components/back-button/back-button.component.tsx
var back_button_component = __webpack_require__(56227);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./app/components/country-list/country-list.module.scss
var country_list_module = __webpack_require__(46652);
var country_list_module_default = /*#__PURE__*/__webpack_require__.n(country_list_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./app/components/icons/Logo.tsx
var Logo = __webpack_require__(23583);
// EXTERNAL MODULE: ./app/components/icons/ArrowRight.tsx
var ArrowRight = __webpack_require__(8426);
// EXTERNAL MODULE: ./app/context/features.context.tsx
var features_context = __webpack_require__(10833);
// EXTERNAL MODULE: ./app/utils/scroll.ts
var utils_scroll = __webpack_require__(21278);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./app/components/country-list/country-list.component.tsx













var CountryList = function CountryList(_ref) {
  var regionPermalink = _ref.regionPermalink,
      label = _ref.label,
      wrapped = _ref.wrapped,
      className = _ref.className,
      _ref$showNames = _ref.showNames,
      showNames = _ref$showNames === void 0 ? false : _ref$showNames,
      onSelect = _ref.onSelect;
  var radioListRef = (0,react.useRef)(null);

  var _useFeaturesContext = (0,features_context/* useFeaturesContext */.Pp)(),
      arrowNavigationEnabled = _useFeaturesContext.arrowNavigationEnabled;

  var _useGetPillowCategory = (0,hooks/* useGetPillowCategoryPath */.gn)(regionPermalink, {
    pageSize: 100
  }),
      data = _useGetPillowCategory.data,
      isLoading = _useGetPillowCategory.isLoading,
      fetchNextPage = _useGetPillowCategory.fetchNextPage;

  var countryList = (data === null || data === void 0 ? void 0 : data.pages.reduce(function (countryList, countryPage) {
    var _countryPage$data$bod;

    return [].concat((0,toConsumableArray/* default */.Z)(countryList), (0,toConsumableArray/* default */.Z)(((_countryPage$data$bod = countryPage.data.body) === null || _countryPage$data$bod === void 0 ? void 0 : _countryPage$data$bod.content) || []));
  }, [])) || [];

  var onForward = function onForward() {
    var _radioListRef$current;

    (_radioListRef$current = radioListRef.current) === null || _radioListRef$current === void 0 ? void 0 : _radioListRef$current.scrollTo({
      left: (0,utils_scroll/* calculateCountryListScroll */.xF)(radioListRef.current.scrollLeft),
      behavior: "smooth"
    });
  };

  var onBackward = function onBackward() {
    var _radioListRef$current2;

    (_radioListRef$current2 = radioListRef.current) === null || _radioListRef$current2 === void 0 ? void 0 : _radioListRef$current2.scrollTo({
      left: (0,utils_scroll/* calculateCountryListScroll */.xF)(radioListRef.current.scrollLeft, true),
      behavior: "smooth"
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (0,clsx_m/* default */.Z)((country_list_module_default()).wrapper, className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (country_list_module_default()).header,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        children: label
      }), !arrowNavigationEnabled && !wrapped && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (country_list_module_default()).buttons,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: (0,clsx_m/* default */.Z)((country_list_module_default()).arrow, (country_list_module_default()).arrow_back),
          onClick: function onClick() {
            return onBackward();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowRight/* default */.Z, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: (country_list_module_default()).arrow,
          onClick: function onClick() {
            return onForward();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowRight/* default */.Z, {})
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (country_list_module_default()).radio_list,
      ref: radioListRef,
      children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (country_list_module_default()).row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((country_list_module_default()).radio_station, (country_list_module_default()).placeholder_item)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((country_list_module_default()).radio_station, (country_list_module_default()).placeholder_item)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((country_list_module_default()).radio_station, (country_list_module_default()).placeholder_item)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((country_list_module_default()).radio_station, (country_list_module_default()).placeholder_item)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((country_list_module_default()).radio_station, (country_list_module_default()).placeholder_item)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((country_list_module_default()).radio_station, (country_list_module_default()).placeholder_item)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((country_list_module_default()).radio_station, (country_list_module_default()).placeholder_item)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,clsx_m/* default */.Z)((country_list_module_default()).radio_station, (country_list_module_default()).placeholder_item)
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((country_list_module_default()).row, (0,defineProperty/* default */.Z)({}, (country_list_module_default()).wrapped, wrapped)),
        "data-navigate-row": true,
        "data-navigate-scrollable": true,
        "data-navigate-scrollable-parent": true,
        children: countryList.map(function (country, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            "data-navigate-item": true,
            tabIndex: 0,
            className: (0,clsx_m/* default */.Z)((country_list_module_default()).radio_station, (0,defineProperty/* default */.Z)({}, (country_list_module_default()).show_station_names, showNames)),
            onClick: function onClick() {
              return onSelect(country);
            },
            children: [country !== null && country !== void 0 && country.logo ? /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: (country === null || country === void 0 ? void 0 : country.logo) || "",
              layout: "intrinsic",
              width: 102,
              className: (country_list_module_default()).cover,
              height: 102,
              objectFit: "cover",
              alt: "",
              unoptimized: true
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (0,clsx_m/* default */.Z)((country_list_module_default()).cover, (country_list_module_default()).no_image),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Logo/* default */.Z, {})
            }), showNames && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (country_list_module_default()).station_title,
              children: country.name
            })]
          }, "country-".concat(index));
        })
      })
    })]
  });
};
// EXTERNAL MODULE: ./app/components/icons/Loader.tsx
var Loader = __webpack_require__(37387);
// EXTERNAL MODULE: ./app/components/country-selector/country-selector.module.scss
var country_selector_module = __webpack_require__(42665);
var country_selector_module_default = /*#__PURE__*/__webpack_require__.n(country_selector_module);
;// CONCATENATED MODULE: ./app/components/country-selector/country-selector.component.tsx












var CountrySelector = function CountrySelector(_ref) {
  var onClose = _ref.onClose,
      onSelect = _ref.onSelect;
  var wrapperRef = (0,keyboard_navigation_hook/* useArrowKeyNavigationOverlay */.Sy)();
  var loadMoreTriggerRef = (0,react.useRef)(null);

  var _useGetPillowCategori = (0,hooks/* useGetPillowCategoriesPath */.Bs)("/radioline_geo", {
    pageSize: 100
  }),
      data = _useGetPillowCategori.data,
      isLoading = _useGetPillowCategori.isLoading,
      fetchNextPage = _useGetPillowCategori.fetchNextPage;

  (0,modal_scroll_hook/* default */.Z)();
  var goBackCallback = (0,react.useCallback)(function () {
    onClose();
  }, [onClose]);
  (0,go_back_hook/* useGoBackEvent */.H)("CountrySelector", goBackCallback);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (country_selector_module_default()).wrapper,
    ref: wrapperRef,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(back_button_component/* BackButtonBar */.K, {
      onClick: onClose
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (country_selector_module_default()).content,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (country_selector_module_default()).countries_wrapper,
        children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (country_selector_module_default()).loader_container,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {})
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [data === null || data === void 0 ? void 0 : data.pages.map(function (countryPage) {
            var _countryPage$data$bod, _countryPage$data$bod2;

            return (_countryPage$data$bod = countryPage.data.body) === null || _countryPage$data$bod === void 0 ? void 0 : (_countryPage$data$bod2 = _countryPage$data$bod.content) === null || _countryPage$data$bod2 === void 0 ? void 0 : _countryPage$data$bod2.map(function (countryRegion) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(CountryList, {
                regionPermalink: countryRegion.permalink,
                label: countryRegion.name,
                showNames: true,
                onSelect: onSelect
              });
            });
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            ref: loadMoreTriggerRef
          })]
        })
      })
    })]
  });
};

/***/ }),

/***/ 40774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var ArrowBack = function ArrowBack(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M50 27.5H19.575L33.55 13.525 30 10 10 30l20 20 3.525-3.525L19.575 32.5H50v-5z",
      fill: "#fff"
    })
  }));
};

var MemoArrowBack = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ArrowBack);
/* harmony default export */ __webpack_exports__["Z"] = (MemoArrowBack);

/***/ }),

/***/ 81222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ isPremium; }
/* harmony export */ });
/* unused harmony export premiumCatalog */
var premiumCatalog = ["radios/selection", "radios/music_hq_premium", "premium/music_hq_premium", "premium/world_best/music", "discover_v2/radios/music"];
var isPremium = function isPremium(permalink) {
  return premiumCatalog.some(function (premiumCatalogItem) {
    return permalink.indexOf(premiumCatalogItem) >= 0;
  });
};

/***/ }),

/***/ 84117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ DiscoverPodcasts; }
/* harmony export */ });
/* harmony import */ var app_components_category_category_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80112);
/* harmony import */ var app_components_country_selector_country_selector_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48778);
/* harmony import */ var app_components_icons_Loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37387);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86010);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69898);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31194);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var app_hooks_lang__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91289);
/* harmony import */ var app_hooks_go_back_hook__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71014);
/* harmony import */ var app_store_slices_user__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38886);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25617);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2962);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);
















var __N_SSG = true;
function DiscoverPodcasts(_ref) {
  var initialData = _ref.initialData,
      countryData = _ref.countryData;
  var t = (0,app_hooks_lang__WEBPACK_IMPORTED_MODULE_11__/* .useTranslate */ .q)();
  var router = (0,next_dist_client_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().container),
    children: router.isFallback ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      className: "loader",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(app_components_icons_Loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_9__/* .NextSeo */ .PB, {
        titleTemplate: "%s",
        title: t("seo_title_discoverPodcast", {
          var1: countryData.name
        }),
        description: t("seo_description_discoverPodcast", {
          var1: countryData.name
        }),
        openGraph: {
          images: [{
            url: "https://www.radioline.co/open-graph.png",
            alt: "Radioline"
          }]
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(PodcastDiscovery, {
        initialData: initialData,
        countryData: countryData
      }, countryData.permalink)]
    })
  });
}

var PodcastDiscovery = function PodcastDiscovery(_ref2) {
  var countryData = _ref2.countryData,
      initialData = _ref2.initialData;
  var router = (0,next_dist_client_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  var t = (0,app_hooks_lang__WEBPACK_IMPORTED_MODULE_11__/* .useTranslate */ .q)();
  (0,app_hooks_go_back_hook__WEBPACK_IMPORTED_MODULE_5__/* .useGoBackHistory */ .J)("DISCOVER/COUNTRY");

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false),
      countrySelectorOpen = _useState[0],
      setCountrySelectorOpen = _useState[1];

  var countryVariables = {
    "--image-background": "url(\"".concat(countryData === null || countryData === void 0 ? void 0 : countryData.logo, "\")")
  };
  var loadMoreTriggerRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
      className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().header)),
      "data-navigate-row": true,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().tabs_wrapper),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
          className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().tabs),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
            href: "/discover/radio/".concat(countryData.countryCode),
            passHref: true,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
              className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().tab),
              "data-navigate-item": true,
              children: t("tabs.stations")
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
            href: "/discover/podcast/".concat(countryData.countryCode),
            passHref: true,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
              className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().tab), (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().active)),
              "data-navigate-item": true,
              children: t("tabs.podcasts")
            })
          })]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().country_wrapper),
        onClick: function onClick() {
          return setCountrySelectorOpen(true);
        },
        "data-navigate-item": true,
        tabIndex: 0,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
          className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().country_name),
          children: t("country-selector")
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
          className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().country_logo),
          style: countryVariables
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().podcasts_tab),
      children: [initialData.map(function (category, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(app_components_category_category_component__WEBPACK_IMPORTED_MODULE_0__/* .Category */ .W, {
          podcast: true,
          items: category.podcasts,
          category: category.podcastCategory,
          className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().category_section)
        }, "discover-podcasts-category-".concat(category.podcastCategory.permalink));
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
        ref: loadMoreTriggerRef
      })]
    }), countrySelectorOpen && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(app_components_country_selector_country_selector_component__WEBPACK_IMPORTED_MODULE_1__/* .CountrySelector */ .P, {
      onClose: function onClose() {
        return setCountrySelectorOpen(false);
      },
      onSelect: function onSelect(category) {
        dispatch(app_store_slices_user__WEBPACK_IMPORTED_MODULE_6__/* .userActions.setSelectedDiscoverLanguage */ .hI.setSelectedDiscoverLanguage({
          logo: category.logo,
          name: category.name,
          permalink: category.permalink
        }));
        setCountrySelectorOpen(false);

        if (category.permalink) {
          router.push("/discover/podcast/".concat(category.permalink.split("/").pop()));
        } else {
          console.error("WRONG FORMAT");
        }
      }
    })]
  });
};

/***/ }),

/***/ 58521:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discover/podcast/[country]",
      function () {
        return __webpack_require__(84117);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71345:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","back":"back-button_back__KRknK","forgot_button":"back-button_forgot_button__Jmz7Z","wrapper":"back-button_wrapper__cmCKR","absolute":"back-button_absolute__HllSl"};

/***/ }),

/***/ 51041:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","header":"category_header__ZzFTh"};

/***/ }),

/***/ 42665:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","wrapper":"country-selector_wrapper__cHTYm","content":"country-selector_content__c_Qxw","countries_wrapper":"country-selector_countries_wrapper__teEuO","loader_container":"country-selector_loader_container__D2jsg"};

/***/ }),

/***/ 31194:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","action_button":"discover_action_button__VjlQl","tab":"discover_tab__gymxE","country_wrapper":"discover_country_wrapper__XEEAL","container":"discover_container__AjGCc","header":"discover_header__5JMcz","stations_container":"discover_stations_container__14adM","tabs":"discover_tabs__LEgsQ","tabs_wrapper":"discover_tabs_wrapper__cs6jO","active":"discover_active__IIhAT","country_name":"discover_country_name__PCYPI","country_logo":"discover_country_logo__i7p5E","podcasts_tab":"discover_podcasts_tab__tR9KE","loader":"discover_loader__B0WZi","category_section":"discover_category_section__druVh"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,2962,6694,4357,8650,9774,2888,179], function() { return __webpack_exec__(58521); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);